﻿import {translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, lowerCase, MvvmTextInput} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useMemo} from "react";
import {GlobalConfig} from "../contexts/GlobalContext";
import useEmailRequiredPolicy from "../policies/emailRequiredPolicy";
import usePhoneRequiredPolicy from "../policies/phoneRequiredPolicy";

type Model = {
	email?: string;
	familyName: string;
	givenName: string;
	phone: string;
}

type UserDataProps = {
	context: IMvvmContextState<Model>;
	global: GlobalConfig;
	hideEmail?: boolean;
}

export default function UserData(props: UserDataProps): JSX.Element {
	const {context, global, hideEmail} = props;
	const phoneData = global.installation.configuration.phoneData;
	const flagImage = `https://flagcdn.com/${lowerCase(phoneData.flag)}.svg`;

	const givenNameValidation = useMemo(() => ({required: translation(PermitTranslations.validation__given_name__required)}), []);
	const familyNameValidation = useMemo(() => ({required: translation(PermitTranslations.validation__family_name__required)}), []);
	const emailValidation = useEmailRequiredPolicy();

	return <>
		<div className="grid">
			<MvvmTextInput type="text"
			               context={context}
			               property="givenName"
			               autoComplete="given-name"
			               label={translation(PermitTranslations.given_name)}
			               autoFocus={true}
			               column="col-1of2"
			               validation={givenNameValidation}/>

			<MvvmTextInput type="text"
			               context={context}
			               property="familyName"
			               autoComplete="family-name"
			               label={translation(PermitTranslations.family_mame)}
			               column="col-1of2"
			               validation={familyNameValidation}/>
		</div>

		{hideEmail ? undefined :
			<MvvmTextInput type="email"
			               context={context}
			               property="email"
			               autoComplete="email webauthn"
			               label={translation(PermitTranslations.email)}
			               validation={emailValidation}/>}

		<MvvmTextInput type="tel"
		               context={context}
		               property="phone"
		               autoComplete="tel-national"
		               label={translation(PermitTranslations.phoneNumber)}
		               column="flex"
		               validation={usePhoneRequiredPolicy(global.installation.countryId)}
		               controlPrefix={
			               <>
							<span className="phone-prefix__flag">
		                        <img src={flagImage} width="26" aria-hidden={true} alt=""/>
							</span>
				               <span>+{phoneData.prefix}</span>
			               </>}
		/>
	</>;
}
